import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButton = ({ tooltip = "Go Back", size = 36, sx = {} }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Go back one page in the browser's history
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={handleBack}
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: "primary.main",
          color: "#fff",
          "&:hover": {
            backgroundColor: "primary.dark",
          },
          ...sx,
        }}
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton;
